export interface IConfig {
  dots: boolean;
  indicator: boolean;
  grid: boolean;
  target: string;
  responsive: {
    [key: number]: SlideResponsive;
  };
}

interface SlideResponsive {
  items: number;
  noOfColumn?: number;
  noOfRows?: number;
  area?: string[];
}
